const goodsArchives = {
  state: {
    modifyCode: '',
    readCode: ''
  },
  mutations: {
    UPDATE_MODIFY_CODE: (state,code) => {
      if(code!==state.modifyCode){
        state.modifyCode = code
      } 
    },
    UPDATE_READ_CODE: (state,code) => {
      state.readCode = code
    }
  },
  actions: {
    updateModifyCode({
      commit}, code) {
      commit('UPDATE_MODIFY_CODE', code)
    },
    updateReadCode({
      commit}, code) {   
        commit('UPDATE_READ_CODE', code)
    }
  }
}

export default goodsArchives;